 export const BASE_URL ="https://ecommerce-d6fh.onrender.com"
//export const BASE_URL ="http://localhost:4000"